export const ATTENDANCE_STATUS_LABELS: Record<string, string> = {
  'FULLTIME': 'Đủ công',
  'FULL': 'Đủ công',
  'MISSING_TIME': 'Thiếu giờ',
  'MISSING': 'Thiếu giờ',
  'MORNING_MISSING': 'Thiếu giờ sáng',
  'AFTERNOON_MISSING': 'Thiếu giờ chiều',
  'MORNING_MISSING_PAID': 'Thiếu giờ sáng (Có phép)',
  'AFTERNOON_MISSING_PAID': 'Thiếu giờ chiều (Có phép)',
  'PAID_LEAVE': 'Nghỉ có phép',
  'MORNING_PAID_LEAVE': 'Nghỉ phép sáng',
  'AFTERNOON_PAID_LEAVE': 'Nghỉ phép chiều',
  'ABSENT': 'Vắng mặt',
  'MORNING_ABSENT': 'Vắng sáng (K/P)',
  'AFTERNOON_ABSENT': 'Vắng chiều (K/P)',
  'OT_APPROVED': 'OT Đã duyệt',
  'OT': 'Tăng ca',
  'NONE': 'Trống'
};

export const HR_EDIT_STATUS_OPTIONS = [
  { label: 'Chưa chấm công', value: '' },
  { label: 'Đi làm đẩy đủ (FULLTIME)', value: 'FULLTIME' },
  { label: 'Thiếu giờ chung (MISSING_TIME)', value: 'MISSING_TIME' },
  { label: 'Vắng sáng (MORNING_MISSING)', value: 'MORNING_MISSING' },
  { label: 'Vắng chiều (AFTERNOON_MISSING)', value: 'AFTERNOON_MISSING' },
  { label: 'Nghỉ phép trọn ngày (PAID_LEAVE)', value: 'PAID_LEAVE' },
  { label: 'Nghỉ phép Sáng (MORNING_PAID_LEAVE)', value: 'MORNING_PAID_LEAVE' },
  { label: 'Nghỉ phép Chiều (AFTERNOON_PAID_LEAVE)', value: 'AFTERNOON_PAID_LEAVE' },
  { label: 'Vắng mặt không phép (ABSENT)', value: 'ABSENT' }
];



